import { useContext } from "react";
import { motion } from "framer-motion";
import { SideBarContext, SideBarProvider } from "./provider";
import MenuToggle from "./MenuToggle";
import MenuContent from "./MenuContent";
import OutsideClickSub from "../outsideClickSub/OutsideClickSub";
import { useIconSize } from "@app/hooks";

const Sidebar = () => {
	return (
		<SideBarProvider>
			<SideBarContent />
		</SideBarProvider>
	)
}

export default Sidebar;

const SideBarContent = () => {
	const { isSideBarOpen, toggleSidebar } = useContext(SideBarContext)
	const width = useIconSize(350)
	return (
		<motion.aside
			className="side"
			animate={{ width: isSideBarOpen ? `${width}px` : undefined }}
			transition={{ type: "spring", stiffness: 300, damping: 30 }}
		>
			<OutsideClickSub
				callback={isSideBarOpen ? toggleSidebar : () => { }}
			>
				<>
					<MenuToggle />
					<MenuContent />
				</>
			</OutsideClickSub>
		</motion.aside>
	)
}
